import { useState } from "react";
import { useAuth } from "../components/context/AuthContext";

export const usePackManagement = (gameId) => {
	const [editingPack, setEditingPack] = useState(null);
	const [packForm, setPackForm] = useState({
		packId: "",
		name: "",
		description: "",
		image: "",
		amount: "",
		retailPrice: "",
		resellerPrice: "",
		costPrice: "",
		vip1Price: "",
		vip2Price: "",
		vip3Price: "",
		provider: "",
		productId: "",
	});

	const token = useAuth().token;

	const handleEditPack = async (pack) => {
		console.log("🔍 Editing pack with data:", pack); // Debug log

		setEditingPack(pack);

		// Ensure all fields are populated with existing data
		setPackForm({
			packId: pack.packId || pack.id || "",
			name: pack.name || "",
			description: pack.description || "",
			image: pack.image || "",
			amount: pack.amount || "",
			retailPrice: pack.retailPrice || "",
			resellerPrice: pack.resellerPrice || "",
			costPrice: pack.costPrice || pack.baseCost || "",
			vip1Price: pack.vip1Price || "",
			vip2Price: pack.vip2Price || "",
			vip3Price: pack.vip3Price || "",
			provider: pack.provider || "",
			productId: pack.productId || "",
		});

		console.log("✅ Pack form populated:", {
			packId: pack.packId || pack.id,
			name: pack.name,
			retailPrice: pack.retailPrice,
			resellerPrice: pack.resellerPrice,
			costPrice: pack.costPrice || pack.baseCost,
			vip1Price: pack.vip1Price,
			vip2Price: pack.vip2Price,
			vip3Price: pack.vip3Price,
			provider: pack.provider,
			productId: pack.productId,
		});
	};

	const handleUpdatePack = async () => {
		// For new games (no gameId), we'll handle pack updates in the parent component
		// This function is only for updating packs of existing games
		if (!gameId) {
			console.warn(
				"handleUpdatePack called without gameId - this is expected for new games"
			);
			return true; // Return true to indicate "success" for local state management
		}

		try {
			console.log("🔄 Updating pack via API:", packForm);

			const response = await fetch(
				`${import.meta.env.VITE_API_URL}/games/${gameId}/packs/${
					editingPack.packId
				}`,
				{
					method: "PUT",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${token}`,
					},
					body: JSON.stringify(packForm),
				}
			);

			if (!response.ok) throw new Error("Failed to update pack");

			console.log("✅ Pack updated successfully via API");
			resetPackForm();
			return true;
		} catch (error) {
			console.error("❌ Pack update failed:", error);
			return false;
		}
	};

	const resetPackForm = () => {
		console.log("🔄 Resetting pack form");
		setEditingPack(null);
		setPackForm({
			packId: "",
			name: "",
			description: "",
			image: "",
			amount: "",
			retailPrice: "",
			resellerPrice: "",
			costPrice: "",
			vip1Price: "",
			vip2Price: "",
			vip3Price: "",
			provider: "",
			productId: "",
		});
	};

	return {
		editingPack,
		packForm,
		setPackForm,
		handleEditPack,
		handleUpdatePack,
		resetPackForm,
	};
};
